module.exports = __webpack_public_path__ + "static/media/placeholder.bd18e688.svg";